import React, { useState, useEffect } from 'react';
import { Row, Col, FormGroup, FormControl, FormLabel, Form, Button, Modal, Alert, FormCheck } from 'react-bootstrap';
import Select from 'react-select';
import LanguageToggle from '../../views/Forms/Private/LanguageToggle';
import cuteMonk1 from '../../assets/img/baolinPrivate/cute_monk1.png';
import cuteMonk2 from '../../assets/img/baolinPrivate/cute_monk2.png';
import RegisterPage from 'views/Pages/RegisterPage';
import { faRegistered } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from 'axios';
import { getSessionLabel, LIANG_HUANG_SESSIONS } from '../../config/liangHuang2026';



function EditGuestModal({ editGuestModal, setEditGuestModal, registrationData, viewingEvent }) {

    // console.log(registrationData)
    const MySwal = withReactContent(Swal);

    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState('');
    const [chinesename, setChinesename] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [groupSize, setGroupSize] = useState(null);
    const [checkInGroupSize, setCheckInGroupSize] = useState(null);
    const [do3R5P, setDo3R5P] = useState(false);
    const [needShuttleBus, setNeedShuttleBus] = useState(false);
    const [isVolunteering, setIsVolunteering] = useState(false);
    const [englishXlation, setEnglishXlation] = useState(false);
    const [cantoneseXlation, setCantoneseXlation] = useState(false);
    const [checkedIn, setCheckedIn] = useState(false);
    const [checkedInTime, setCheckedInTime] = useState(null);
    const [registrationTime, setRegistrationTime] = useState(null);
    const [sessionSelections, setSessionSelections] = useState({});
    // State for error messages
    const [firstnameError, setFirstnameError] = useState(null);
    const [lastnameError, setLastnameError] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [phoneError, setPhoneError] = useState(null);
    const [groupSizeError, setGroupSizeError] = useState(null);
    const [checkInGroupSizeError, setCheckInGroupSizeError] = useState(null);

    const [language, setLanguage] = useState("English"); // Assuming default language is English

    // Group Size options for Select component
    const groupSizeOptions = Array.from({ length: 15 }, (_, i) => ({
        value: i + 1,
        label: `${i + 1}`,
    }));

    const [firstnameModifyChecked, setFirstnameModifyChecked] = useState(false);
    const [lastnameModifyChecked, setLastnameModifyChecked] = useState(false);
    const [chinesenameModifyChecked, setChinesenameModifyChecked] = useState(false);
    const [phoneModifyChecked, setPhoneModifyChecked] = useState(false);
    const [emailModifyChecked, setEmailModifyChecked] = useState(false);
    const [do3R5PModifyChecked, setDo3R5PModifyChecked] = useState(false);
    const [shuttleModifyChecked, setShuttleModifyChecked] = useState(false);
    const [volunteerModifyChecked, setVolunteerModifyChecked] = useState(false);
    const [englishXlationModifyChecked, setEnglishXlationModifyChecked] = useState(false);
    const [cantoneseXlationModifyChecked, setCantoneseXlationModifyChecked] = useState(false);
    const [groupSizeModifyChecked, setGroupSizeModifyChecked] = useState(false);
    const [checkInGroupSizeModifyChecked, setCheckInGroupSizeModifyChecked] = useState(false);
    const [sessionsModifyChecked, setSessionsModifyChecked] = useState(false);

    const handleFirstnameModifyChange = (event) => {
        const isChecked = event.target.checked;
        setFirstnameModifyChecked(isChecked);
        // When unchecked, reset the firstname to the original value from registrationData
        if (!isChecked && registrationData) {
            setFirstname(registrationData.firstname);
        }
    };
    const handleLastnameModifyChange = (event) => {
        const isChecked = event.target.checked;
        setLastnameModifyChecked(isChecked);
        // When unchecked, reset the firstname to the original value from registrationData
        if (!isChecked && registrationData) {
            setLastname(registrationData.lastname);
        }
    };

    const handleChinesenameModifyChange = (event) => {
        const isChecked = event.target.checked;
        setChinesenameModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setChinesename(registrationData.chinesename);
        }
    };

    const handlePhoneModifyChange = (event) => {
        const isChecked = event.target.checked;
        setPhoneModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setPhone(registrationData.phone);
        }
    };

    const handleEmailModifyChange = (event) => {
        const isChecked = event.target.checked;
        setEmailModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setEmail(registrationData.email);
        }
    };

    const handleDo3R5PModifyChange = (event) => {
        const isChecked = event.target.checked;
        setDo3R5PModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setDo3R5P(registrationData.do3R5P);
        }
    };

    const handleShuttleModifyChange = (event) => {
        const isChecked = event.target.checked;
        setShuttleModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setNeedShuttleBus(registrationData.needShuttleBus);
        }
    };

    const handleVolunteerModifyChange = (event) => {
        const isChecked = event.target.checked;
        setVolunteerModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setIsVolunteering(registrationData.isVolunteering);
        }
    };

    const handleEnglishXlationModifyChange = (event) => {
        const isChecked = event.target.checked;
        setEnglishXlationModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setEnglishXlation(registrationData.englishXlation);
        }
    };

    const handleCantoneseXlationModifyChange = (event) => {
        const isChecked = event.target.checked;
        setCantoneseXlationModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setCantoneseXlation(registrationData.cantoneseXlation);
        }
    };

    const handleGroupSizeModifyChange = (event) => {
        const isChecked = event.target.checked;
        setGroupSizeModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setGroupSize(registrationData.relatives);
        }
    };

    const handleCheckInGroupSizeModifyChange = (event) => {
        const isChecked = event.target.checked;
        setCheckInGroupSizeModifyChecked(isChecked);
        if (!isChecked && registrationData) {
            setCheckInGroupSize(registrationData.checkInGroupSize);
        }
    };


    useEffect(() => {
        if (registrationData !== null) {
            setFirstname(registrationData.firstname);
            setLastname(registrationData.lastname);
            setChinesename(registrationData.chinesename);
            setPhone(registrationData.phone);
            setEmail(registrationData.email);
            setGroupSize(registrationData.relatives);
            setCheckInGroupSize(registrationData.checkInGroupSize);
            setDo3R5P(registrationData.do3R5P);
            setNeedShuttleBus(registrationData.needShuttleBus);
            setIsVolunteering(registrationData.isVolunteering);
            setEnglishXlation(registrationData.englishXlation);
            setCantoneseXlation(registrationData.cantoneseXlation);
            setCheckedIn(registrationData.checkedIn)
            setRegistrationTime(registrationData.registrationTime)
            setSessionSelections(Object.fromEntries(
                LIANG_HUANG_SESSIONS.map((session) => [session.field, Boolean(registrationData[session.field])])
            ));

        }
    }, [registrationData]);

    const Alert3R5P = (
        <Alert className="alert-with-icon" variant="info">
            <span data-notify="icon" className="nc-icon nc-bell-55"></span>
            <span data-notify="message">
                {language === "English" ? "If you wish to register for the Three Refuges and Five Precepts, please contact the Bao Lin reception" : "欲報名正受三皈依或五戒，請洽寶林禪寺"}
            </span>
        </Alert>
    );

    const validateForm = () => {
        let isValid = true;

        // Email validation
        // const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // if (!emailRegex.test(email)) {
        //     setEmailError(language === "English" ? "Invalid email format." : "電子郵件格式不正確");
        //     isValid = false;
        // } else {
        //     setEmailError(null);
        // }

        // First name validation
        if (!firstname.trim()) {
            setFirstnameError(language === "English" ? "First name is required." : "未填寫英文姓");
            isValid = false;
        } else {
            setFirstnameError(null);
        }

        // Last name validation
        if (!lastname.trim()) {
            setLastnameError(language === "English" ? "Last name is required." : "未填寫英文名");
            isValid = false;
        } else {
            setLastnameError(null);
        }

        // Phone validation
        if (!phone.trim()) {
            setPhoneError(language === "English" ? "Please enter a contact phone number." : "請填息聯繫電話以方便聯絡.");
            isValid = false;
        } else {
            setPhoneError(null);
        }

        // Group Size validation
        if (groupSizeModifyChecked && (groupSize === null || groupSize === undefined)) {
            setGroupSizeError(language === "English" ? "Please select group size." : "請選擇隨行人數");
            isValid = false;
        } else {
            setGroupSizeError(null);
        }

        // Check In Group Size validation
        if (checkInGroupSizeModifyChecked && (checkInGroupSize === null || checkInGroupSize === undefined)) {
            setCheckInGroupSizeError(language === "English" ? "Please select check-in group size." : "請選擇實際到場人數");
            isValid = false;
        } else {
            setCheckInGroupSizeError(null);
        }

        return isValid;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validateForm()) {
            // Determine which fields have been changed
            const changes = [
                firstnameModifyChecked && { field: 'First Name', before: registrationData.firstname, after: firstname },
                lastnameModifyChecked && { field: 'Last Name', before: registrationData.lastname, after: lastname },
                chinesenameModifyChecked && { field: 'Chinese Name', before: registrationData.chinesename, after: chinesename },
                emailModifyChecked && { field: 'Email', before: registrationData.email, after: email },
                phoneModifyChecked && { field: 'Phone', before: registrationData.phone, after: phone },
                groupSizeModifyChecked && { field: 'Group Size', before: registrationData.relatives, after: groupSize },
                checkInGroupSizeModifyChecked && { field: 'Check In Group Size', before: registrationData.checkInGroupSize, after: checkInGroupSize },
                do3R5PModifyChecked && { field: '3R5P', before: registrationData.do3R5P ? "Yes" : "No", after: do3R5P ? "Yes" : "No" },
                shuttleModifyChecked && { field: 'Shuttle Bus', before: registrationData.needShuttleBus ? "Yes" : "No", after: needShuttleBus ? "Yes" : "No" },
                volunteerModifyChecked && { field: 'Volunteering', before: registrationData.isVolunteering ? "Yes" : "No", after: isVolunteering ? "Yes" : "No" },
                englishXlationModifyChecked && { field: 'English Translation', before: registrationData.englishXlation ? "Yes" : "No", after: englishXlation ? "Yes" : "No" },
                cantoneseXlationModifyChecked && { field: 'Cantonese Translation', before: registrationData.cantoneseXlation ? "Yes" : "No", after: cantoneseXlation ? "Yes" : "No" },
                sessionsModifyChecked && {
                    field: 'Liang Huang Sessions',
                    before: LIANG_HUANG_SESSIONS.filter((session) => registrationData[session.field]).map((session) => session.scroll).join(', '),
                    after: LIANG_HUANG_SESSIONS.filter((session) => sessionSelections[session.field]).map((session) => session.scroll).join(', '),
                },
                // ... Repeat for other fields
            ].filter(Boolean); // Filter out unchecked fields

            // Prepare table content for SweetAlert
            const tableContent = `
            <style>
                .swal-table {
                    width: 100%;
                    margin-left: auto;
                    margin-right: auto;
                    border-collapse: collapse;
                }
                .swal-table th, .swal-table td {
                    padding: 8px; /* Adjust padding as needed */
                    text-align: left; /* Default alignment */
                }
                .swal-table th:nth-child(1), .swal-table td:nth-child(1) { /* Information column */
                    text-align: left;
                }
                .swal-table th:nth-child(3), .swal-table td:nth-child(3) { /* After column */
                    text-align: right;
                }
                .swal-table tbody tr:nth-child(odd) {
                    background-color: #f2f2f2; /* Light gray for striped effect */
                }
            </style>
            <table class="swal-table">
                <thead>
                    <tr><th>Information</th><th>Before</th><th>After</th></tr>
                </thead>
                <tbody>
                    ${changes.map(change => `<tr><td>${change.field}</td><td>${change.before}</td><td>${change.after}</td></tr>`).join('')}
                </tbody>
            </table>
            `;

            // Show SweetAlert2 Confirmation
            const result = await MySwal.fire({
                title: 'Please Confirm Changes',
                html: tableContent,
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            });

            if (result.isConfirmed) {
                // Prepare thepayload for API call
                const updatedData = {
                    id: registrationData.id,
                    ...(firstnameModifyChecked && { firstname }),
                    ...(lastnameModifyChecked && { lastname }),
                    ...(chinesenameModifyChecked && { chinesename }),
                    ...(emailModifyChecked && { email }),
                    ...(phoneModifyChecked && { phone }),
                    ...(groupSizeModifyChecked && { relatives: groupSize }),
                    ...(checkInGroupSizeModifyChecked && { checkInGroupSize }),
                    ...(do3R5PModifyChecked && { do3R5P }),
                    ...(shuttleModifyChecked && { needShuttleBus }),
                    ...(volunteerModifyChecked && { isVolunteering }),
                    ...(englishXlationModifyChecked && { englishXlation }),
                    ...(cantoneseXlationModifyChecked && { cantoneseXlation }),
                    ...(sessionsModifyChecked && sessionSelections),
                };
                try {
                    // Send the API request
                    const endpoint = viewingEvent === 'lianghuang' ? 'event' : viewingEvent;
                    const response = await axios.put(`${process.env.REACT_APP_SERVER_URL}/${endpoint}/updateguest`, updatedData);
                    console.log(response.data);
                    if (response.status === 200) {
                        // Display a success message
                        await Swal.fire({
                            title: 'Success!',
                            text: 'The update was successful.',
                            icon: 'success',
                            confirmButtonText: 'OK'
                        });
                    }
                    // Handle response, like closing the modal or refreshing the data
                    setEditGuestModal(false);
                    // Refresh the page
                    window.location.reload();
                } catch (error) {
                    console.error('Error updating registration:', error);
                    // Check if the error response is available and has a specific reason
                    let errorMessage = 'An unknown error occurred. Please try again later.';
                    console.log(error.response.data.detail["reason"])
                    if (error.response && error.response.data && error.response.data.detail && error.response.data.detail.reason === "Duplicate entry") {
                        errorMessage = 'Duplicated with other guest!';
                    }
                    // Display an error alert
                    await Swal.fire({
                        title: 'Error!',
                        text: errorMessage,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }
            }

        }
    }

    return (
        <>
            <Modal
                className=" modal-primary"
                onHide={() => {
                    setEditGuestModal(!editGuestModal);
                }}
                show={editGuestModal}
                size="lg">
                <Modal.Body >
                    <div>
                        <Form onSubmit={handleSubmit}>
                            <p className="text-center mb-2 font-weight-bold">
                                <img src={cuteMonk1} alt="Company Logo" width="40" className="mr-3" />
                                {language === "English" ? "View Guest Information" : "報名信息"}
                                <img src={cuteMonk2} alt="Company Logo" width="40" className="ml-3" />
                            </p>

                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <hr />
                                    <p>The guest was registred at <span className='font-weight-bold text-primary'>{registrationTime}</span></p>
                                    <hr />
                                </Col>

                            </Row>
                            {/* <LanguageToggle setLanguage={setLanguage} /> */}

                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "First Name (Required)" : "英 文 名（必填）"}<span className="text-danger">*</span></FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl
                                                type="text"
                                                name="firstname"
                                                maxLength="30"
                                                placeholder="ex: Mike"
                                                value={firstname}
                                                onChange={(event) => setFirstname(event.target.value)}
                                                disabled={!firstnameModifyChecked} // Disable input field based on checkbox state
                                            />
                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="FirstnameModify"
                                                        type="checkbox"
                                                        checked={firstnameModifyChecked}
                                                        onChange={handleFirstnameModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                        {firstnameError && <small className="text-danger">{firstnameError}</small>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            {viewingEvent === 'lianghuang' && (
                                <Row>
                                    <Col md={{ span: 10, offset: 1 }}>
                                        <FormGroup>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <FormLabel className="font-weight-bold mb-0">
                                                    {language === "English" ? "Registered sessions" : "已報名共修時段"}
                                                </FormLabel>
                                                {/* This theme hides the native checkbox and draws it with
                                                    .form-check-sign, so every box needs that span to be
                                                    visible and clickable -- same structure as the fields above. */}
                                                <Form.Check>
                                                    <Form.Check.Label>
                                                        <Form.Check.Input
                                                            type="checkbox"
                                                            checked={sessionsModifyChecked}
                                                            onChange={(event) => setSessionsModifyChecked(event.target.checked)}
                                                        ></Form.Check.Input>
                                                        <span className="form-check-sign"></span>
                                                        Modify
                                                    </Form.Check.Label>
                                                </Form.Check>
                                            </div>
                                            {LIANG_HUANG_SESSIONS.map((session) => (
                                                <Form.Check key={session.field} className={sessionsModifyChecked ? "" : "disabled"}>
                                                    <Form.Check.Label>
                                                        <Form.Check.Input
                                                            type="checkbox"
                                                            checked={Boolean(sessionSelections[session.field])}
                                                            disabled={!sessionsModifyChecked}
                                                            onChange={(event) => setSessionSelections((current) => ({
                                                                ...current,
                                                                [session.field]: event.target.checked,
                                                            }))}
                                                        ></Form.Check.Input>
                                                        <span className="form-check-sign"></span>
                                                        {getSessionLabel(session, language)}
                                                    </Form.Check.Label>
                                                </Form.Check>
                                            ))}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            )}
                            <Row>

                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "Last Name (Required)" : "英 文 姓（必填）"}<span className="text-danger">*</span></FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl type="text" name="lastname" maxLength="30" placeholder="ex: Andrew"
                                                value={lastname} onChange={(event) => setLastname(event.target.value)} disabled={!lastnameModifyChecked} />
                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="LastnameModify"
                                                        type="checkbox"
                                                        checked={lastnameModifyChecked}
                                                        onChange={handleLastnameModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                        {lastnameError && <small className="text-danger">{lastnameError}</small>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "Chinese Name" : "中 文 姓 名"}</FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl type="text" name="chinesename" maxLength="30"
                                                placeholder={language === "English" ? "ex: Wukong" : "ex：悟空"} value={chinesename}
                                                onChange={(event) => setChinesename(event.target.value)} disabled={!chinesenameModifyChecked} />
                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="ChinesenameModify"
                                                        type="checkbox"
                                                        checked={chinesenameModifyChecked}
                                                        onChange={handleChinesenameModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                    </FormGroup>
                                </Col>

                            </Row>
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "Phone Number (Required for contact)" : "電 話 號 碼（必填，聯絡用）"} <span className="text-danger">*</span></FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl type="number" name="phone" maxLength="30"
                                                placeholder="ex: 0433233343" value={phone} onChange={(event) => setPhone(event.target.value)} disabled={!phoneModifyChecked} />

                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="PhoneModify"
                                                        type="checkbox"
                                                        checked={phoneModifyChecked}
                                                        onChange={handlePhoneModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                        {phoneError && <small className="text-danger">{phoneError}</small>}
                                    </FormGroup>


                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "Email (Required for contact)" : "電 子 郵 件（選填，聯絡用）"} </FormLabel>
                                        <div className="d-flex align-items-center">
                                            <FormControl type="email" name="email" maxLength="50"
                                                placeholder="ex: wukong@baolin.com" value={email} disabled={!emailModifyChecked}
                                                onChange={(event) => setEmail(event.target.value)} />

                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="EmailModify"
                                                        type="checkbox"
                                                        checked={emailModifyChecked}
                                                        onChange={handleEmailModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                        {emailError && <small className="text-danger">{emailError} </small>}
                                    </FormGroup>
                                </Col>

                            </Row>
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "Registered Group Size" : "報名人數"} <span className="text-danger">*</span></FormLabel>
                                        <div className="d-flex align-items-center">
                                            <div style={{ flex: 1, marginRight: '15px' }}>
                                                <Select
                                                    className="react-select primary"
                                                    classNamePrefix="react-select"
                                                    name="groupSizeSelect"
                                                    value={groupSizeOptions.find((option) => option.value === groupSize)}
                                                    onChange={(option) => setGroupSize(option.value)}
                                                    options={groupSizeOptions}
                                                    placeholder={language === "English" ? "Select number" : "选择人数"}
                                                    isDisabled={!groupSizeModifyChecked}
                                                />
                                            </div>
                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="GroupSizeModify"
                                                        type="checkbox"
                                                        checked={groupSizeModifyChecked}
                                                        onChange={handleGroupSizeModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                        {groupSizeError && <small className="text-danger">{groupSizeError}</small>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 10, offset: 1 }}>
                                    <FormGroup>
                                        <FormLabel>{language === "English" ? "Actual Attendance Group Size (實際到場人數)" : "實際到場人數"} <span className="text-danger">*</span></FormLabel>
                                        <div className="d-flex align-items-center">
                                            <div style={{ flex: 1, marginRight: '15px' }}>
                                                <Select
                                                    className="react-select primary"
                                                    classNamePrefix="react-select"
                                                    name="checkInGroupSizeSelect"
                                                    value={groupSizeOptions.find((option) => option.value === checkInGroupSize)}
                                                    onChange={(option) => setCheckInGroupSize(option.value)}
                                                    options={groupSizeOptions}
                                                    placeholder={language === "English" ? "Select number" : "选择人数"}
                                                    isDisabled={!checkInGroupSizeModifyChecked}
                                                />
                                            </div>
                                            <Form.Check>
                                                <Form.Check.Label>
                                                    <Form.Check.Input
                                                        label="CheckInGroupSizeModify"
                                                        type="checkbox"
                                                        checked={checkInGroupSizeModifyChecked}
                                                        onChange={handleCheckInGroupSizeModifyChange}
                                                    ></Form.Check.Input>
                                                    <span className="form-check-sign"></span>
                                                    Modify
                                                </Form.Check.Label>
                                            </Form.Check>
                                        </div>
                                        {checkInGroupSizeError && <small className="text-danger">{checkInGroupSizeError}</small>}
                                    </FormGroup>
                                </Col>
                            </Row>

                            {/* <Row className="mb-3">
                                <Col md={{ span: 10, offset: 1 }} className="d-flex align-items-center justify-content-between">
                                    <span className="description"> {language === "English" ? "Registered for the 3R5P?" : "已報名三皈五戒"}</span>
                                    <div className="d-flex align-items-center justify-content-end mb-2">
                                        <label className="mb-0">
                                            <span className={`mr-2 ${do3R5P ? "text-success" : ""}`}>
                                                {language === "English" ? (do3R5P ? "Yes" : "No") : (do3R5P ? "是" : "否")}
                                            </span>
                                        </label>
                                        <Form.Check
                                            type="switch"
                                            checked={do3R5P}
                                            id="do3R5P"
                                            onChange={(e) => setDo3R5P(e.target.checked)}
                                            disabled={!do3R5PModifyChecked}
                                        />
                                        <Form.Check>
                                            <Form.Check.Label>
                                                <Form.Check.Input
                                                    label="Modify"
                                                    type="checkbox"
                                                    checked={do3R5PModifyChecked}
                                                    onChange={handleDo3R5PModifyChange}
                                                ></Form.Check.Input>
                                                <span className="form-check-sign"></span>
                                                Modify
                                            </Form.Check.Label>
                                        </Form.Check>
                                    </div>

                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 10, offset: 1 }} >
                                    {do3R5P ? null : Alert3R5P}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={{ span: 10, offset: 1 }} className="d-flex align-items-center justify-content-between">
                                    <span className="description">
                                        {language === "English" ? "Shuttle bus pickup from Glen Iris train station?" : "需要接駁車(Glen Iris火車站到寶林)?"}
                                    </span>
                                    <div className="d-flex align-items-center justify-content-end mb-2">
                                        <label className="mb-0">
                                            <span className={`mr-2 mt-1 ${needShuttleBus ? "text-success" : ""}`}>
                                                {language === "English" ? (needShuttleBus ? "Yes" : "No") : (needShuttleBus ? "需要" : "不需要")}
                                            </span>
                                        </label>
                                        <Form.Check
                                            type="switch"
                                            checked={needShuttleBus}
                                            id="needShuttleBus"
                                            onChange={(e) => setNeedShuttleBus(e.target.checked)}
                                            disabled={!shuttleModifyChecked}
                                        />
                                        <Form.Check>
                                            <Form.Check.Label>
                                                <Form.Check.Input
                                                    label="Modify"
                                                    type="checkbox"
                                                    checked={shuttleModifyChecked}
                                                    onChange={handleShuttleModifyChange}
                                                ></Form.Check.Input>
                                                <span className="form-check-sign"></span>
                                                Modify
                                            </Form.Check.Label>
                                        </Form.Check>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={{ span: 10, offset: 1 }} className="d-flex align-items-center justify-content-between">
                                    <span className="description">
                                        {language === "English" ? "Volunteering on the day?" : "當日義工"}
                                    </span>
                                    <div className="d-flex align-items-center justify-content-end mb-2">
                                        <label className="mb-0">
                                            <span className={`mr-2 ${isVolunteering ? "text-success" : ""}`}>
                                                {language === "English" ? (isVolunteering ? "Yes" : "No") : (isVolunteering ? "是" : "否")}
                                            </span>
                                        </label>
                                        <Form.Check
                                            type="switch"
                                            checked={isVolunteering}
                                            id="isVolunteering"
                                            onChange={(e) => setIsVolunteering(e.target.checked)}
                                            disabled={!volunteerModifyChecked}
                                        />
                                        <Form.Check>
                                            <Form.Check.Label>
                                                <Form.Check.Input
                                                    label="Modify"
                                                    type="checkbox"
                                                    checked={volunteerModifyChecked}
                                                    onChange={handleVolunteerModifyChange}
                                                ></Form.Check.Input>
                                                <span className="form-check-sign"></span>
                                                Modify
                                            </Form.Check.Label>
                                        </Form.Check>
                                    </div>

                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={{ span: 10, offset: 1 }} className="d-flex align-items-center justify-content-between">
                                    <span className="description">
                                        {language === "English" ? "Do you need translation?" : "需要翻譯"}
                                    </span>
                                    <div className="d-flex flex-column align-items-end">
                                        <div>
                                            <div className="d-flex align-items-center justify-content-end mb-2">
                                                <label className="mb-0">
                                                    <span className={`mr-2 ${englishXlation ? "text-success" : ""}`}>
                                                        {language === "English" ? "English" : "英語"}
                                                    </span>
                                                </label>
                                                <Form.Check
                                                    type="switch"
                                                    id="englishXlation"
                                                    checked={englishXlation}
                                                    onChange={(e) => setEnglishXlation(e.target.checked)}
                                                    disabled={!englishXlationModifyChecked}
                                                />
                                                <Form.Check>
                                                    <Form.Check.Label>
                                                        <Form.Check.Input
                                                            label="Modify"
                                                            type="checkbox"
                                                            checked={englishXlationModifyChecked}
                                                            onChange={handleEnglishXlationModifyChange}
                                                        ></Form.Check.Input>
                                                        <span className="form-check-sign"></span>
                                                        Modify
                                                    </Form.Check.Label>
                                                </Form.Check>
                                            </div>

                                            <div className="d-flex align-items-center justify-content-end">
                                                <label className="mb-0">
                                                    <span className={`mr-2 ${cantoneseXlation ? "text-success" : ""}`}>
                                                        {language === "English" ? "Cantonese" : "廣東話"}
                                                    </span>
                                                </label>
                                                <Form.Check
                                                    type="switch"
                                                    id="cantoneseXlation"
                                                    checked={cantoneseXlation}
                                                    onChange={(e) => setCantoneseXlation(e.target.checked)}
                                                    disabled={!cantoneseXlationModifyChecked}
                                                />
                                                <Form.Check>
                                                    <Form.Check.Label>
                                                        <Form.Check.Input
                                                            label="Modify"
                                                            type="checkbox"
                                                            checked={cantoneseXlationModifyChecked}
                                                            onChange={handleCantoneseXlationModifyChange}
                                                        ></Form.Check.Input>
                                                        <span className="form-check-sign"></span>
                                                        Modify
                                                    </Form.Check.Label>
                                                </Form.Check>
                                            </div>
                                        </div>
                                    </div>

                                </Col>
                            </Row> */}
                            {/* <Button type="submit" className="mt-3">Submit</Button> */}
                        </Form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setEditGuestModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit" onClick={handleSubmit}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    );

}

export default EditGuestModal;
